import {
    ACCOUNT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
    ACCOUNT_SIGNALS_MANAGEMENT_PAGE_URL,
    HOME_PAGE_ROUTE,
    INTENT_SIGNALS_MANAGEMENT_INTRO_PAGE_ROUTE,
    INTENT_SIGNALS_MANAGEMENT_INTRO_PAGE_URL,
    INTENT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
    INTENT_SIGNALS_MANAGEMENT_PAGE_URL,
    SI_ROOT_ROUTE,
} from "app/pages/sales-intelligence/constants/routes";
import {
    MANAGEMENT_SAVED_SEARCH_WEBHOOKS_ROUTE,
    MANAGEMENT_SIGNALS_API_ROUTE,
    MANAGEMENT_SIGNALS_API_URL,
    MANAGEMENT_SIGNALS_REST_API_ROUTE,
    MANAGEMENT_SIGNALS_REST_API_URL,
    SAVED_SEARCH_WEBHOOKS_MANAGEMENT_URL,
} from "app/pages/sales-intelligence/constants/sl_routes";
import ManageIntentSignalsPageContainer from "app/pages/sales-intelligence/pages/manage-signals/ManageIntentSignalsPageContainer";
import ManageSignalsPageContainer from "app/pages/sales-intelligence/pages/manage-signals/ManageSignalsPageContainer";
import SavedSearchWebhooksManagementContainer from "app/pages/sales-intelligence/pages/management/containers/SavedSearchWebhooksManagementContainer/SavedSearchWebhooksManagementContainer";
import SignalsManagementIntegrationContainer from "app/pages/sales-intelligence/pages/management/containers/SignalsManagementIntegrationContainer/SignalsManagementIntegrationContainer";
import SignalsRestApiManagementContainer from "app/pages/sales-intelligence/pages/management/containers/SignalsRestApiManagementContainer/SignalsRestApiManagementContainer";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import { fallback } from "app/routes/handlers/redirectFunctions/fallback";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const signalsManagementConfig: RouterStateConfig = {
    [ACCOUNT_SIGNALS_MANAGEMENT_PAGE_ROUTE]: {
        configId: "SalesWorkspace",
        parent: SI_ROOT_ROUTE,
        stateId: ACCOUNT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
        pageTitle: "si.pages.signals_management.document_title",
        url: ACCOUNT_SIGNALS_MANAGEMENT_PAGE_URL,
        component: ManageSignalsPageContainer,
        trackingId: {
            section: "Manage_signals",
            subSection: "Manage_admin",
            subSubSection: "Signals_management",
        },
        pageId: {
            section: "Manage_signals",
            subSection: "Manage_admin",
            subSubSection: "Signals_management",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        isHidden: !salesSettingsHelper.isHighLevelAccount(),
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: HOME_PAGE_ROUTE,
            }),
        ),
    },
    [INTENT_SIGNALS_MANAGEMENT_PAGE_ROUTE]: {
        configId: "SalesWorkspace",
        parent: SI_ROOT_ROUTE,
        stateId: INTENT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
        pageTitle: "si.pages.intent.document_title",
        url: INTENT_SIGNALS_MANAGEMENT_PAGE_URL,
        component: ManageIntentSignalsPageContainer,
        trackingId: {
            section: "Intent_signals",
            subSection: "Intent_admin",
            subSubSection: "Intent_management",
        },
        pageId: {
            section: "Intent_signals",
            subSection: "Intent_admin",
            subSubSection: "Intent_management",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        isHidden: !salesSettingsHelper.isIntentSignalsEnabled(),
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: HOME_PAGE_ROUTE,
            }),
        ),
    },
    [INTENT_SIGNALS_MANAGEMENT_INTRO_PAGE_ROUTE]: {
        configId: "SalesWorkspace",
        parent: SI_ROOT_ROUTE,
        stateId: INTENT_SIGNALS_MANAGEMENT_INTRO_PAGE_ROUTE,
        pageTitle: "si.pages.intent.document_title",
        url: INTENT_SIGNALS_MANAGEMENT_INTRO_PAGE_URL,
        component: ManageIntentSignalsPageContainer,
        trackingId: {
            section: "Intent_signals",
            subSection: "Intent_admin",
            subSubSection: "Intent_intro",
        },
        pageId: {
            section: "Intent_signals",
            subSection: "Intent_admin",
            subSubSection: "Intent_intro",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        isHidden: !salesSettingsHelper.isIntentSignalsEnabled(),
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: HOME_PAGE_ROUTE,
            }),
        ),
    },
    [MANAGEMENT_SIGNALS_API_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: MANAGEMENT_SIGNALS_API_URL,
        configId: "SalesWorkspace",
        stateId: MANAGEMENT_SIGNALS_API_ROUTE,
        component: SignalsManagementIntegrationContainer,
        pageTitle: "si.pages.management.document_title",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "Manage signals API",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: !salesSettingsHelper.isSalesApiSignalsEnabled,
    },
    [MANAGEMENT_SIGNALS_REST_API_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: MANAGEMENT_SIGNALS_REST_API_URL,
        configId: "SalesWorkspace",
        stateId: MANAGEMENT_SIGNALS_REST_API_ROUTE,
        component: SignalsRestApiManagementContainer,
        pageTitle: "si.pages.management.document_title",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "Manage Signals REST API",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
    },
    [MANAGEMENT_SAVED_SEARCH_WEBHOOKS_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: SAVED_SEARCH_WEBHOOKS_MANAGEMENT_URL,
        configId: "SalesWorkspace",
        stateId: MANAGEMENT_SAVED_SEARCH_WEBHOOKS_ROUTE,
        component: SavedSearchWebhooksManagementContainer,
        pageTitle: "si.pages.management.document_title",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "Manage saved search webhooks",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: !salesSettingsHelper.isSavedSearchWebhooksEnabled,
    },
};
